import React, {PropTypes} from 'react';

const Entry = ({
  virtualEntryId,
  selected,
  bowlerName,
  bowlerWillBeRemoved,
  entryName,
  virtualEventName,
  onSelectChecked
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child custom-checkbox-container"
      style={{width: 25}}>
      <input
        type="checkbox"
        id={`entry-${virtualEntryId}`}
        checked={selected}
        onChange={() => onSelectChecked(virtualEntryId, !selected)}
      />
      <label
        htmlFor={`entry-${virtualEntryId}`} />
    </div>
    { bowlerName ?
      <div className="list-group-item-labeled-child" 
        style={{width: 450}}>
        <span>{'Bowler Name'}</span>
        <span>{`${virtualEventName} - ${bowlerName}`}{ bowlerWillBeRemoved ? <i>(Will be removed if unchecked)</i> : null}</span>
      </div> :
      <div className="list-group-item-labeled-child" 
        style={{width: 450}}>
        <span>{'Team Name'}</span>
        <span>{`${virtualEventName} - ${entryName}`} <i>(Will be removed if unchecked)</i></span>
      </div>
    }
  </div>
);

Entry.propTypes = {
  virtualEntryId: PropTypes.string,
  selected: PropTypes.bool,
  bowlerName: PropTypes.string,
  bowlerWillBeRemoved: PropTypes.bool,
  entryName: PropTypes.string,
  virtualEventName: PropTypes.string,
  onSelectChecked: PropTypes.func
};

Entry.defaultProps = {
};

export default Entry;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/VirtualEntry.jsx